<template>
  <div class="checkbox-buttons" :style="objectStyle">
    <div
      v-for="(objectItem, index) of arrayItems"
      :key="index"
      class="checkbox-buttons__button"
      :class="{ selected: arrayValuesSelected.includes(objectItem.value) }"
      role="checkbox"
      @click="onClickButton(objectItem)"
    >
      {{ objectItem.text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckBoxButtons',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    slice: {
      type: [Object, null],
      default: null,
    },
  },
  computed: {
    arrayItems() {
      if (this.slice) {
        return this.items.slice(this.slice.start, this.slice.end);
      }
      return this.items;
    },
    objectStyle() {
      return {
        'grid-template-columns': this.arrayItems.length ? `repeat(${this.arrayItems.length}, 1fr)` : '1fr',
      };
    },
    arrayValuesSelected() {
      const arrayValuesSelected = this.items.reduce((accumulator, objectItem) => {
        if (objectItem.isSelected) {
          accumulator.push(objectItem.value);
        }
        return accumulator;
      }, []);
      this.$emit('input', arrayValuesSelected);
      return arrayValuesSelected;
    },
  },
  methods: {
    onClickButton(objectItem) {
      if (!objectItem.isSelected || this.arrayValuesSelected.length > 1) {
        objectItem.isSelected = !objectItem.isSelected;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.checkbox-buttons {
  width: 100%;
  display: grid;

  & > div {
    padding: 0.5em;
    flex-grow: 1;
    border: solid 1px #abd047;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Roboto-Medium, sans-serif;
    font-size: 15px;
    font-weight: 500;
    font-stretch: condensed;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #132839;
    cursor: pointer;

    &.selected {
      background-color: #cbee6b;
    }

    &:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
}
</style>
